import { createAction } from '@reduxjs/toolkit';

import type {
  ChannelUpdateGreetingPayload,
  ChannelUpdateLLMSettingsPayload,
  ChannelUpdateSafetyFiltersPayload,
  ChannelUpdateStatusPayload,
  ChannelUpdateStylePromptPayload,
  VoiceChannelResetAsrConfigPayload,
  VoiceChannelResetAudioEnhancementPayload,
  VoiceChannelResetBargeInConfigPayload,
  VoiceChannelResetSilenceFillerUtterancesPayload,
  VoiceChannelResetTemperaturePayload,
  VoiceChannelResetVadConfigPayload,
  VoiceChannelUpdateASRSettingsPayload,
  VoiceChannelUpdateAsrConfigPayload,
  VoiceChannelUpdateAudioEnhancementPayload,
  VoiceChannelUpdateBargeInConfigPayload,
  VoiceChannelUpdateDisclaimerPayload,
  VoiceChannelUpdateSilenceFillerUtterancesPayload,
  VoiceChannelUpdateTemperaturePayload,
  VoiceChannelUpdateVadConfigPayload,
} from '@polyai/stream/commands/handlers/channels';

import { CHANNELS_SLICE_NAME } from './constants';

// Voice Channel Updates
export const updateVoiceChannelDisclaimer =
  createAction<VoiceChannelUpdateDisclaimerPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelDisclaimer`,
  );

export const updateVoiceChannelASRSettings =
  createAction<VoiceChannelUpdateASRSettingsPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelASRSettings`,
  );

// Channel Status Updates
export const updateChannelStatus = createAction<ChannelUpdateStatusPayload>(
  `${CHANNELS_SLICE_NAME}/updateChannelStatus`,
);

// Channel Config Updates
export const updateChannelGreeting = createAction<ChannelUpdateGreetingPayload>(
  `${CHANNELS_SLICE_NAME}/updateChannelGreeting`,
);

export const updateChannelStylePrompt =
  createAction<ChannelUpdateStylePromptPayload>(
    `${CHANNELS_SLICE_NAME}/updateChannelStylePrompt`,
  );

export const updateChannelSafetyFilters =
  createAction<ChannelUpdateSafetyFiltersPayload>(
    `${CHANNELS_SLICE_NAME}/updateChannelSafetyFilters`,
  );

export const updateChannelLLMSettings =
  createAction<ChannelUpdateLLMSettingsPayload>(
    `${CHANNELS_SLICE_NAME}/updateChannelLLMSettings`,
  );

export const updateVoiceChannelVadConfig =
  createAction<VoiceChannelUpdateVadConfigPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelVadConfig`,
  );

export const updateVoiceChannelAudioEnhancement =
  createAction<VoiceChannelUpdateAudioEnhancementPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelAudioEnhancement`,
  );

export const resetVoiceChannelAudioEnhancement =
  createAction<VoiceChannelResetAudioEnhancementPayload>(
    `${CHANNELS_SLICE_NAME}/resetVoiceChannelAudioEnhancement`,
  );

export const updateVoiceChannelSilenceFillerUtterances =
  createAction<VoiceChannelUpdateSilenceFillerUtterancesPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelSilenceFillerUtterances`,
  );

export const resetVoiceChannelSilenceFillerUtterances =
  createAction<VoiceChannelResetSilenceFillerUtterancesPayload>(
    `${CHANNELS_SLICE_NAME}/resetVoiceChannelSilenceFillerUtterances`,
  );

export const updateVoiceChannelAsrConfig =
  createAction<VoiceChannelUpdateAsrConfigPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelAsrConfig`,
  );

export const resetVoiceChannelAsrConfig =
  createAction<VoiceChannelResetAsrConfigPayload>(
    `${CHANNELS_SLICE_NAME}/resetVoiceChannelAsrConfig`,
  );

export const updateVoiceChannelBargeInConfig =
  createAction<VoiceChannelUpdateBargeInConfigPayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelBargeInConfig`,
  );

export const resetVoiceChannelBargeInConfig =
  createAction<VoiceChannelResetBargeInConfigPayload>(
    `${CHANNELS_SLICE_NAME}/resetVoiceChannelBargeInConfig`,
  );

export const updateVoiceChannelTemperature =
  createAction<VoiceChannelUpdateTemperaturePayload>(
    `${CHANNELS_SLICE_NAME}/updateVoiceChannelTemperature`,
  );

export const resetVoiceChannelTemperature =
  createAction<VoiceChannelResetTemperaturePayload>(
    `${CHANNELS_SLICE_NAME}/resetVoiceChannelTemperature`,
  );

export const resetVoiceChannelVadConfig =
  createAction<VoiceChannelResetVadConfigPayload>(
    `${CHANNELS_SLICE_NAME}/resetVoiceChannelVadConfig`,
  );
